import { render, staticRenderFns } from "./index.vue?vue&type=template&id=eaaa637c&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=eaaa637c&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=eaaa637c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaaa637c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaaa637c')) {
      api.createRecord('eaaa637c', component.options)
    } else {
      api.reload('eaaa637c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=eaaa637c&scoped=true&lang=pug", function () {
      api.rerender('eaaa637c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/currentClassApplication/index.vue"
export default component.exports